import { useMarkOnMount } from './useMarkOnMount';
import { useMeasure } from './useMeasure';
export const useMarkAndMeasureOnMount = (measurement, dimensions = {}) => {
  useMarkOnMount(measurement.end);
  useMeasure(measurement, {}, dimensions);
};